export function isAvailableSize (sizes, name) {
    return Array.isArray(sizes) && sizes.some(size => size.use === true && size.name === name)
}

export function resolveDefaultSize (sizes, defaultSize) {
    if (isAvailableSize(sizes, defaultSize)) return defaultSize
    const available = Array.isArray(sizes) ? sizes.find(size => size.use === true) : null
    return available ? available.name : ''
}



// WEBPACK FOOTER //
// ./src/helpers/printSize.js